/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SeasonDefinitionDto = {
    id?: number;
    name?: string;
    minStartDate?: string;
    maxEndDate?: string;
    description?: string;
    type?: SeasonDefinitionDto.type;
};
export namespace SeasonDefinitionDto {
    export enum type {
        SEASON = 'SEASON',
        PRESEASON = 'PRESEASON',
    }
}

